import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query"
import { SiInstagram, SiFacebook, SiTiktok, SiYoutube } from "@icons-pack/react-simple-icons"

import Helpers from "@/components/Helpers"
import LoginCarousel from "@/components/LoginCarousel"
import LoginForm from "@/components/LoginForm"
import FullerLogo from "@/assets/opi-fuller.svg"
import { Toaster } from "@/components/ui/sonner"

const queryClient = new QueryClient()

const App = () => (
  <QueryClientProvider client={queryClient}>
    <Toaster />
    <section className="flex min-h-screen items-center bg-gray-100">
      <div className="hidden p-6 lg:flex lg:w-1/2 lg:justify-center">
        <LoginCarousel />
      </div>

      <div className="flex flex-1 items-center justify-center p-6">
        <div className="w-full max-w-lg space-y-10">
          <header>
            <div className="flex justify-center">
              <img src={FullerLogo} className="w-60" alt="" />
            </div>

            <p className="text-center text-black/45">
              <span className="font-bold">Bienvenid@</span> para iniciar por{" "}
              favor teclea tu usuario y contraseña respetando mayúsculas y minúsculas.
            </p>
          </header>

          <div>
            <LoginForm />
          </div>

          <div className="space-y-2">
            <Helpers />
          </div>

          <footer className="space-y-5">
            <div className="text-center">
              <a href="https://fuller.com.mx/legales.html" className="underline">
                Aviso de privacidad
              </a>
            </div>

            <div className="grid grid-cols-4 justify-center">
              <div className="inline-flex justify-center">
                <a target="_blank" href="https://www.instagram.com/fuller.mexico.oficial/">
                  <SiInstagram />
                </a>
              </div>

              <div className="inline-flex justify-center">
                <a target="_blank" href="https://www.facebook.com/fuller.mexico.oficial">
                  <SiFacebook />
                </a>
              </div>

              <div className="inline-flex justify-center">
                <a target="_blank" href="https://www.tiktok.com/@fuller.mexico.oficial">
                  <SiTiktok />
                </a>
              </div>

              <div className="inline-flex justify-center">
                <a target="_blank" href="https://www.youtube.com/@fuller.mexico.oficial">
                  <SiYoutube />
                </a>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </section>
  </QueryClientProvider>
)

export default App
